(function () {
  function formatTime(value) {
    if (!Number.isFinite(value)) return '0:00';
    return Math.floor(value / 60) + ':' + String(Math.floor(value % 60)).padStart(2, '0');
  }

  function init(root) {
    if (root.dataset.srAudioReady === 'true') return;
    root.dataset.srAudioReady = 'true';

    const cards = Array.from(root.querySelectorAll('.sr-audio__card'));
    const audio = root.querySelector('.sr-audio__audio');
    const modal = root.querySelector('.sr-audio__modal');
    const dialog = root.querySelector('.sr-audio__dialog');
    const modalBg = root.querySelector('.sr-audio__bg');
    const badge = root.querySelector('.sr-audio__badge');
    const title = root.querySelector('.sr-audio__copy h3');
    const description = root.querySelector('.sr-audio__copy p:not(.visually-hidden)');
    const metadata = root.querySelector('.sr-audio__metadata');
    const waveform = root.querySelector('.sr-audio__waveform');
    const playButton = root.querySelector('[data-action="play"]');
    const progress = root.querySelector('.sr-audio__timeline input');
    const currentTime = root.querySelector('[data-current-time]');
    const duration = root.querySelector('[data-duration]');
    const status = root.querySelector('[data-player-status]');
    const toggle = root.querySelector('[data-audio-toggle]');
    const extraCards = cards.filter(function (card) { return card.classList.contains('sr-audio__card--extra'); });
    let currentIndex = -1;
    let lastTrigger = null;

    function renderMetadata(button) {
      metadata.textContent = '';
      [
        ['Tempo', [button.dataset.audioBpm, button.dataset.audioInstruments].filter(Boolean).join(' ')],
        ['Ambient layer', button.dataset.audioAmbient]
      ].forEach(function (pair) {
        if (!pair[1]) return;
        const item = document.createElement('div');
        const label = document.createElement('b');
        const value = document.createElement('span');
        item.className = 'sr-audio__metadata-item';
        label.textContent = pair[0];
        value.textContent = pair[1];
        item.append(label, value);
        metadata.append(item);
      });
    }

    function setPlayingCard(index) {
      cards.forEach(function (card, cardIndex) {
        card.classList.toggle('is-playing', cardIndex === index);
      });
    }

    function updatePlayButton() {
      const playing = !audio.paused && !audio.ended;
      const playIcon = playButton.querySelector('.sr-audio__play-icon');
      const playLabel = playButton.querySelector('[data-play-label]');
      if (playIcon) playIcon.innerHTML = playing ? '&#10074;&#10074;' : '&#9654;';
      if (playLabel) playLabel.textContent = playing ? 'Pause' : 'Play';
      playButton.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      waveform.classList.toggle('is-playing', playing);
    }

    function openModal() {
      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sr-audio-modal-open');
      root.querySelector('[data-action="close"]').focus();
    }

    function closeModal() {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      currentIndex = -1;
      setPlayingCard(-1);
      waveform.classList.remove('is-playing');
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sr-audio-modal-open');
      progress.value = 0;
      currentTime.textContent = '0:00';
      duration.textContent = '0:00';
      status.textContent = 'Audio stopped';
      updatePlayButton();
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }

    function loadTrack(index, shouldPlay) {
      const card = cards[index];
      if (!card) return;
      const button = card.querySelector('.sr-audio__cover');
      currentIndex = index;
      lastTrigger = button;
      audio.src = button.dataset.audioUrl || '';
      audio.load();
      title.textContent = button.dataset.audioTitle || 'Audio track';
      description.textContent = button.dataset.audioDescription || '';
      renderMetadata(button);

      if (button.dataset.audioCover) {
        if (modalBg) modalBg.style.backgroundImage = 'url("' + button.dataset.audioCover + '")';
      } else if (modalBg) {
        modalBg.style.removeProperty('background-image');
      }
      if (badge) {
        var scenario = button.dataset.audioScenario || '';
        badge.textContent = scenario ? 'Scenario \u00b7 ' + scenario : '';
        badge.hidden = !scenario;
      }
      if (dialog) dialog.classList.toggle('has-cover', !!button.dataset.audioCover);

      progress.value = 0;
      currentTime.textContent = '0:00';
      duration.textContent = '0:00';
      setPlayingCard(index);
      openModal();
      status.textContent = 'Playing ' + (button.dataset.audioTitle || 'audio');
      if (shouldPlay !== false && button.dataset.audioUrl) audio.play().catch(updatePlayButton);
      updatePlayButton();
    }

    cards.forEach(function (card, index) {
      card.querySelector('.sr-audio__cover').addEventListener('click', function () {
        loadTrack(index);
      });
    });

    if (toggle && extraCards.length) {
      toggle.addEventListener('click', function () {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        extraCards.forEach(function (card) { card.hidden = !nextExpanded; });
        root.classList.toggle('is-expanded', nextExpanded);
        toggle.setAttribute('aria-expanded', String(nextExpanded));
        toggle.querySelector('[data-audio-toggle-label]').textContent = nextExpanded ? 'Show less' : 'See all';
      });
    }

    root.querySelectorAll('.sr-audio__nav a').forEach(function (link) {
      link.addEventListener('click', function (event) {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        window.history.replaceState(null, '', link.getAttribute('href'));
      });
    });

    playButton.addEventListener('click', function () {
      if (currentIndex < 0) loadTrack(0);
      else if (audio.paused) audio.play();
      else audio.pause();
      updatePlayButton();
    });
    root.querySelector('[data-action="previous"]').addEventListener('click', function () { loadTrack((currentIndex - 1 + cards.length) % cards.length); });
    root.querySelector('[data-action="next"]').addEventListener('click', function () { loadTrack((currentIndex + 1) % cards.length); });
    root.querySelector('[data-action="close"]').addEventListener('click', closeModal);
    root.querySelector('[data-action="stop"]').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-visible')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled])'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    // Keep the total duration showing the track's REAL length.
    // A fresh src can fire durationchange instead of loadedmetadata, and the
    // value is briefly non-finite while the header is still arriving, so listen
    // to every stage that can settle it and ignore unusable values.
    function syncDuration() {
      const d = audio.duration;
      if (Number.isFinite(d) && d > 0) duration.textContent = formatTime(d);
    }
    audio.addEventListener('loadedmetadata', syncDuration);
    audio.addEventListener('durationchange', syncDuration);
    audio.addEventListener('loadeddata', syncDuration);
    audio.addEventListener('canplay', syncDuration);
    audio.addEventListener('timeupdate', function () {
      if (audio.duration) progress.value = (audio.currentTime / audio.duration) * 100;
      currentTime.textContent = formatTime(audio.currentTime);
    });
    audio.addEventListener('play', updatePlayButton);
    audio.addEventListener('pause', updatePlayButton);
    audio.addEventListener('ended', function () { loadTrack((currentIndex + 1) % cards.length); });
    progress.addEventListener('input', function () {
      if (audio.duration) audio.currentTime = (Number(progress.value) / 100) * audio.duration;
    });
  }

  function boot() {
    document.querySelectorAll('[data-sr-audio-section]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
